import $ from 'jquery';

document.addEventListener('DOMContentLoaded', () => {
  // Close all Bootstrap collapses when document click is outside any collapse
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.collapse')) {
      $('.collapse').collapse('hide');
    }
  });

  // Close all Bootstrap collapses when Esc key is pressed
  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') {
      $('.collapse').collapse('hide');
    }
  });
});